export default {
  title: 'Export chats history',
  modal: {
    title: 'Export chats history',
    description: 'Please, specify the period. All received and sent messages from every chat will be collected to the report.<br>Don\'t close the window while report is proceeded.',
    from: 'From',
    to: 'To',
    btn_submit: 'Create report',
  },
  alert: {
    start: {
      title: 'The report in progress',
    },
    end: {
      title: 'The report is ready!',
      description: 'Download the report or find it in the Documents section',
    },
  },
}
